"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = lookForBinder;

var _defaultbinders = _interopRequireDefault(require("./defaultbinders"));

// tries to find a binder for given node
function lookForBinder(node) {
  for (var i = 0; i < _defaultbinders["default"].length; i++) {
    var binder = _defaultbinders["default"][i].call(node, node);

    if (binder) {
      return binder;
    }
  }

  return undefined;
}
//# sourceMappingURL=lookforbinder.js.map